import React from 'react'
import { util } from '../../../util'
import PropTypes from 'prop-types'

const GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

const generateGrid = () => {
    const styles = {}
    GRID_SIZES.forEach(function (size) {
        const key = 'grid-row-col-'.concat(size)

        if (size === true) {
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: '100%',
            }
            return
        }

        if (size === 'auto') {
            styles[key] = {
                flexBasis: 'auto',
                flexGrow: 0,
                maxWidth: 'none',
            }
            return
        }

        const width = ''.concat(Math.round((size / 12) * 10e7) / 10e5, '%')

        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width,
        }
    })
    return styles
}

const Grid = ({ children, className }) => {
    return <div className={util.joinClasses('grid', className)}>{children}</div>
}

const Row = ({
    children,
    className,
    justify,
    alignItems,
    bgColor,
    showHighlight = false,
    ...rest
}) => {
    const rowClassName = util.joinClasses(
        'grid-row',
        justify && `justify-${justify}`,
        alignItems && `align-items-${alignItems}`,
        showHighlight && !!bgColor && `bg-color-${bgColor}`,
        className
    )

    return (
        <div className={rowClassName} {...rest}>
            {children}
        </div>
    )
}

const Col = ({
    children,
    xs,
    className,
    showUnderline,
    showUpperline,
    alignSelf,
    textAlign,
    justify,
    bgColor,
    showHighlight = false,
    ...rest
}) => {
    const styles = generateGrid()
    const key = `grid-row-col-${xs}`

    const colClassName = util.joinClasses(
        'grid-row-col',
        alignSelf && `align-self-${alignSelf}`,
        textAlign && `text-align-${textAlign}`,
        justify && `justify-${justify}`,
        showHighlight && !!bgColor && `bg-color-${bgColor}`,
        className
    )

    return (
        <div style={{ ...styles[key] }} className={colClassName} {...rest}>
            {showUpperline ? <div className={'wide-underline'} /> : null}
            {children}
            {showUnderline ? <div className={'wide-underline'} /> : null}
        </div>
    )
}

Col.propTypes = {
    alignSelf: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline']),
    justify: PropTypes.oneOf([
        'flex-start',
        'flex-end',
        'space-between',
        'space-around',
        'space-evenly',
        'center',
    ]),
}

Grid.Col = Col
Grid.Row = Row

export default Grid
